module.exports = __webpack_public_path__ + "img/phone-blank.86f9ebcd.png";